import { render, staticRenderFns } from "./ShowMagazine.vue?vue&type=template&id=f147c766&"
import script from "./ShowMagazine.vue?vue&type=script&lang=js&"
export * from "./ShowMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports